import React from "react";
import { useTranslation } from "react-i18next";
import ProductionEventLogTable from "./ProductionEventLogTable";
import { useProductionEventLog } from "../hooks/useProductionEventLog";

interface Props {
  workOrderId?: string;
}

/**
 * Status log panel shown on /work-order/6020.
 * Fetches from the append-only production event log API — no more hardcoded
 * status name strings, no more 6423 filter. All events (ISSUED, RECEIVED,
 * RETURN_DONE, etc.) appear in chronological order.
 */
const RNStatusLogTable: React.FC<Props> = ({ workOrderId }) => {
  const { t } = useTranslation();
  const { events, loading, error } = useProductionEventLog(workOrderId ?? null);

  return (
    <ProductionEventLogTable
      title={t("os.statusLog.title")}
      events={events}
      loading={loading}
      error={error ?? undefined}
      emptyText={t("os.statusLog.empty")}
    />
  );
};

export default RNStatusLogTable;
